import React from 'react';
import PropTypes from 'prop-types';
import TextHeader from "./TextHeader";
import MeetingTypeCard from "./MeetingTypeCard";
import css from './SelectMeetingType.css'
import SubmitStudentAPI from "./SubmitStudentAPI";
import {urlParams} from "../utils/request";
import useError from "../hooks/useError";

function SelectMeetingType(props) {

  const [{success: submitStudentSuccess, error: submitStudentError}, {onSubmitStudentApi}] = SubmitStudentAPI();

  useError(submitStudentError, props.setError);

  if (submitStudentSuccess) {
    props.goToConfirmationPage();
  }

  const selectOneOnOne = () => {
    if (props.shouldSkipCourseAndMoreInformationPages) {
      const params = urlParams({
        studentId: props.studentId,
        serviceId: props.serviceId,
        reasonId: props.reasonId,
        kioskId: props.kioskId,
        courseId: 0,
        groupSessionId: 0,
      }, false);
      onSubmitStudentApi(params);
    } else {
      props.onSelectOneOnOne();
    }
  };

  return (
    <div className={css['container']}>
      <TextHeader
        upperText={props.instructionsText}
      />
      <div className={css['card-container']}>
        <MeetingTypeCard
          title={props.sessionGroupText}
          imageUrl={"../images/starfish/starfish_group.png"}
          onClick={props.onSelectSessionGroup}
        />
        <MeetingTypeCard
          title={props.oneOnOneText}
          imageUrl={"../images/starfish/starfish_hand_shake.png"}
          onClick={selectOneOnOne}
        />
      </div>
    </div>
  );
}

SelectMeetingType.propTypes = {
  onSelectSessionGroup: PropTypes.func.isRequired,
  onSelectOneOnOne: PropTypes.func.isRequired,
  sessionGroupText: PropTypes.string.isRequired,
  oneOnOneText: PropTypes.string.isRequired,
  instructionsText: PropTypes.string,
  setError: PropTypes.func.isRequired,
  studentId: PropTypes.number.isRequired,
  reasonId: PropTypes.number.isRequired,
  kioskId: PropTypes.number.isRequired,
  serviceId: PropTypes.number.isRequired,
  shouldSkipCourseAndMoreInformationPages: PropTypes.bool.isRequired,
  goToConfirmationPage: PropTypes.func.isRequired
};

export default SelectMeetingType;
